export function initContactAnchor() {
  const form = document.querySelector('#footer');
  const y = () => form.getBoundingClientRect().top + window.scrollY;
  
  function scrollToForm() {
    const urlObj = new URL(window.location);
    const pathname = urlObj.pathname;
    const segments = pathname.split('/');
    const lastSegment = segments.pop();
    if (lastSegment === 'contacts') {
      window.scrollTo({top: y(), behavior: 'smooth'});
    }
  }
  
  window.onload = scrollToForm;
}


